import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";

export default function showActionCenterBanner(viewer: ISelfieQuery["selfie"]): boolean {
  if (!viewer || viewer.__typename === "PendingUser") {
    return false;
  }

  return viewer.showActionCenterBanner;
}
